import gql from 'graphql-tag';
import history from '../../history';
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';

export function editVehicle(id, vehicleName, vehicleType, vehicleNumber, vehicleStatus, vehicleColor, isChildSeatAvailable, isWheelChairAvailable) {

    return async (dispatch, getState, { client }) => {
        const mutation = gql`
            mutation updateVehicle($id: Int, $vehicleName: String, $vehicleType: Int, $vehicleNumber: String, $vehicleStatus: String, $vehicleColor: String, $isChildSeatAvailable: Boolean, $isWheelChairAvailable: Boolean) {
                updateVehicle(
                id: $id
                vehicleName: $vehicleName,
                vehicleType: $vehicleType
                vehicleNumber: $vehicleNumber,
                vehicleStatus: $vehicleStatus
                vehicleColor: $vehicleColor
                isChildSeatAvailable: $isChildSeatAvailable
                isWheelChairAvailable: $isWheelChairAvailable
                ){
                status
                }
            }
        `;

        const query = gql`
            query getAllVehicles($currentPage: Int){
                getAllVehicles(currentPage: $currentPage){
                count
                vehicleData{
                    id
                    vehicleType
                    vehicleNumber
                    vehicleName 
                    vehicleStatus
                    vehicleColor
                    isChildSeatAvailable
                    isWheelChairAvailable
                    category{
                        categoryName
                    }
                    user{
                        email
                        profile{
                        firstName
                        }
                    }
                }
                }
            }
        `;
        dispatch(setLoaderStart('EditVehicle'));

        const { data } = await client.mutate({
            mutation,
            variables: {
                id,
                vehicleName,
                vehicleType,
                vehicleNumber,
                vehicleStatus,
                vehicleColor,
                isChildSeatAvailable,
                isWheelChairAvailable
            },
            refetchQueries: [{
                query,
                variables: {
                    currentPage: 1
                }
            }]
        })
        dispatch(setLoaderComplete('EditVehicle'));

        if (data && data.updateVehicle && data.updateVehicle.status === 200) {
            history.push('/siteadmin/vehicles')
            toastr.success('Success!', 'Vehicle details has been updated successfully')
        } else if (data && data.updateVehicle && data.updateVehicle.status === 400) {
            history.push('/siteadmin/vehicles');
            toastr.error('Failed', "Can't Change the status as currently, they are on a trip, Please try again later");
        } else {
            history.push('/siteadmin/vehicles');
            toastr.error('Failed', "Something went wrong");
        }
    }
}